module.exports = __webpack_public_path__ + "img/bathtub.1720ac2.svg";